<template>
    <div v-if="floating" class="floatingv2 p-relative" @click.stop="onClickFloating">
        <PhotoAndLastSeen
            class="no-touch display-table m-a"
            :lastSignInAt="floating.user.last_sign_in_at"
            :profile="floating.user.photo_url"
            :userId="floating.user.id"
            :sent="floating.sent"
            :likeProfile="true"
        />
        <i @click.stop="deleteFloatingInterest" class="material-icons">close</i>
        <div class="info">
            <div class="nickname-age flex-row items-center">
                <div v-if="!userChat" class="nickname lines-1" v-html="floating.user.profile.nickname" />
                <div v-else class="nickname lines-1" v-html="$nameOrNick(floating.user)" />
                <div class="age lines-1" v-html="Age" />
                <BadgeFriendType :user="floating" :chat="userChat" />
            </div>
            <div class="height-region flex-row">
                <div v-html="floating.user.profile.height" />
                <div v-html="'ㅣ'" style="color: #c8c8cd" />
                <div v-html="$options.filters.noDetail(floating.user.profile.region_name)" />
                <Distance :distance="floating.user.$$distance" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FloatingV2',
    props: ['floating', 'chatId'],
    computed: {
        friendType() {
            return this.$options.filters.friendType(this.floating)
        },
        chat() {
            return this.$store.getters.chat || {}
        },
        Age() {
            const user = this.floating.user
            const age = this.$options.filters.asAge(user.profile.birthday)

            return `${age}`
        },
        userChat() {
            return (this.$store.getters.chatList || []).find(c => c.user_id === this.floating.user.id)
        },
    },
    methods: {
        deleteFloatingInterest() {
            this.$store.dispatch('deleteChatFloatingInterest', {
                chat: this.chat,
                floating: this.floating,
                reject: true,
            })
        },
        async onClickFloating() {
            if (this.$store.getters.isMobile) {
                this.$emit('clickFloating')
                return
            }
            try {
                await this.$store.dispatch('loadIntroducingUser', this.floating.user.id)
            } catch (e) {
                this.$toast.error(e.data)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
$panel-width-friends: 264px;
$img-size: calc((#{$panel-width-friends} - 8px - 2 * 16px) / 2);

.floatingv2 {
    user-select: none;
    width: $img-size;

    &:last-child {
        margin-bottom: 16px;
    }

    /deep/ .photo-and-last-seen {
        padding: 0;
        border-radius: 8px;
    }

    /deep/ .img-profile {
        width: $img-size;
        height: $img-size;
        padding: 0;
        border-radius: 8px;
    }

    .info {
        .flex-row * {
            flex: 0 0 auto;
        }
        margin-top: 4px;
    }

    .badge {
        display: table;
        line-height: 16px;
    }

    .nickname {
        color: black;
        font-size: 12px;
        line-height: 16px;
        margin-right: 4px;
        max-width: 51px;
        font-family: NotoSans-Medium;
    }
    .age {
        color: black;
        font-size: 12px;
        line-height: 16px;
        margin-right: 4px;
        // max-width: 80px;
        font-family: NotoSans-Medium;
    }

    .height-region {
        font-size: 10px;
        letter-spacing: -0.2px;

        .distance {
            margin-left: 4px;
        }
    }

    .material-icons {
        color: white;
        width: 24px;
        height: 24px;
        font-size: 20px;
        position: absolute;
        right: 8px;
        top: 8px;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
